var render = function render() {
  var _vm$flowListRaw, _vm$flowListRaw2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    attrs: {
      "title": "表单审批",
      "size": "small"
    }
  }, [_c('template', {
    slot: "extra"
  }, [_c('a-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 2), _c('div', {
    staticClass: "process-audit-container"
  }, [_c('div', {
    staticClass: "position-right"
  }, [_c('div', {
    staticClass: "sliderbar-off",
    on: {
      "click": _vm.clickChange
    }
  }, [_c('a-icon', {
    attrs: {
      "type": _vm.sliderbar ? 'double-right' : 'double-left'
    }
  }), _vm._v(" 流转记录 ")], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sliderbarShow,
      expression: "sliderbarShow"
    }],
    class: !_vm.sliderbar ? 'right-close' : 'right-open'
  }, [_c('div', {
    staticClass: "right-card"
  }, [_c('div', {
    staticClass: "flow"
  }, [_c('a-timeline', _vm._l(_vm.mergedFlowList, function (item, index) {
    return _c('a-timeline-item', {
      key: index,
      attrs: {
        "color": _vm.getCircleColor(item)
      }
    }, [_c('p', [_vm._v(_vm._s("".concat(item.taskName)))]), _c('el-card', {
      attrs: {
        "body-style": {
          padding: '10px'
        }
      }
    }, [!item.multiInstance ? _c('div', {
      staticClass: "div-class"
    }, [_c('div', [item.assigneeName ? _c('label', {
      staticStyle: {
        "font-weight": "normal",
        "margin-right": "30px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v("实际办理： " + _vm._s(item.assigneeName))]), _c('el-popover', {
      attrs: {
        "trigger": "hover",
        "placement": "top"
      }
    }, [_c('p', [_vm._v(_vm._s(item.deptName))]), _c('template', {
      staticClass: "name-wrapper",
      slot: "reference"
    }, [_c('el-tag', {
      staticStyle: {
        "cursor": "pointer",
        "max-width": "200px",
        "overflow": "hidden",
        "white-space": "nowrap",
        "text-overflow": "ellipsis"
      },
      attrs: {
        "type": "info",
        "size": "mini"
      }
    }, [_vm._v(" " + _vm._s(item.deptName) + " ")])], 1)], 2)], 1) : _vm._e()]), index == 0 ? [_c('div', [_vm._v(" 申请时间： "), _c('label', {
      staticStyle: {
        "color": "#8a909c",
        "font-weight": "normal"
      }
    }, [_vm._v(_vm._s(item.finishTime))])])] : _vm._e(), index != 0 ? [_c('div', [_c('label', {
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_vm._v("接收时间：")]), _c('label', {
      staticStyle: {
        "color": "#8a909c",
        "font-weight": "normal"
      }
    }, [_vm._v(_vm._s(item.createTime))])]), index === _vm.mergedFlowList.length - 1 && item.comment === null ? _c('div', [_c('label', {
      staticStyle: {
        "font-weight": "normal",
        "margin-right": "30px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_vm.currCheck.comment ? _c('div', {
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v("实际办理： " + _vm._s(_vm.currCheck.userName))]) : _c('div', {
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v("等待办理：")]), _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-wrap": "wrap"
      }
    }, _vm._l(item.organPosList, function (organItem, organIndex) {
      return _c('el-tag', {
        key: organIndex,
        staticStyle: {
          "cursor": "pointer",
          "max-width": "300px",
          "overflow": "hidden",
          "white-space": "nowrap",
          "text-overflow": "ellipsis",
          "margin": "0 5px 10px 0"
        },
        attrs: {
          "type": "info",
          "size": "mini"
        }
      }, [!organItem.userId && organItem.organId ? _c('p', [_vm._v(_vm._s(organItem.organName + '/' + organItem.postName))]) : organItem.userId && !organItem.organId ? _c('p', [_vm._v(_vm._s(organItem.userName))]) : organItem.userId && organItem.organId ? _c('p', [_vm._v(_vm._s(organItem.userName + '(' + organItem.organName + '/' + organItem.postName + ')'))]) : _vm._e()]);
    }), 1)]), _c('label', [_vm._v(" 审核状态： "), _c('a-tag', {
      staticClass: "tag-border-blue"
    }, [_vm._v("待　审")])], 1)]) : _vm._e(), _c('div', [item.finishTime ? _c('label', {
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_vm._v("办结时间：")]) : _vm._e(), _c('label', {
      staticStyle: {
        "color": "#8a909c",
        "font-weight": "normal"
      }
    }, [_vm._v(_vm._s(item.finishTime))])])] : _vm._e(), item.comment != undefined ? _c('div', [index != 0 ? _c('div', [_c('label', [_vm._v(" 审核状态： "), item.comment.type == 1 ? _c('a-tag', {
      staticClass: "tag-border-green"
    }, [_vm._v("通　过")]) : _vm._e(), item.comment.type == 3 || item.comment.type == 2 ? _c('a-tag', {
      staticClass: "tag-border-orange"
    }, [_vm._v("驳　回")]) : _vm._e(), item.comment.type == 6 ? _c('a-tag', {
      staticClass: "tag-border-red"
    }, [_vm._v("不通过")]) : _vm._e()], 1)]) : _vm._e(), index != 0 ? _c('div', [_c('label', {
      staticClass: "noline"
    }, [_vm._v(" 审核意见： "), _c('el-popover', {
      attrs: {
        "trigger": "hover",
        "placement": "top"
      }
    }, [_c('p', [_vm._v(_vm._s(item.comment.comment))]), _c('template', {
      staticClass: "name-wrapper",
      slot: "reference"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#8a909c",
        "font-weight": "normal"
      }
    }, [_vm._v(_vm._s(item.comment.comment))])])], 2)], 1)]) : _vm._e()]) : _vm._e(), item.flowCustomLabelList ? [_vm._l(item.flowCustomLabelList, function (fitem, findex) {
      return [item.taskId == fitem.taskId ? [findex == 0 ? _c('hr', {
        staticStyle: {
          "height": "1px",
          "border": "none",
          "background-color": "rgba(0,0,0,0.15)"
        }
      }) : _vm._e(), fitem.inputType != 'img' ? _c('div', [_c('div', {
        staticClass: "ccc"
      }, [_c('label', {
        staticClass: "label-font"
      }, [_vm._v(_vm._s(fitem.inputKey) + "：")]), _c('label', {
        staticClass: "label-font1",
        staticStyle: {
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(fitem.inputValue))])])]) : _vm._e(), fitem.inputType == 'img' ? _c('div', [_c('div', {
        staticClass: "ccc"
      }, [_c('label', {
        staticClass: "label-font"
      }, [_vm._v(_vm._s(fitem.inputKey) + "：")]), _c('label', [_c('img', {
        staticStyle: {
          "width": "4.95rem",
          "height": "4.95rem"
        },
        attrs: {
          "src": fitem.inputValue,
          "alt": "签名图片"
        }
      })])])]) : _vm._e()] : _vm._e()];
    })] : _vm._e()], 2) : _c('div', {
      staticClass: "multi-instance-group"
    }, [_c('div', {
      staticClass: "group-header"
    }, [_c('span', [_vm._v("会签（共 " + _vm._s(item.subTasks.length) + " 人）")]), _c('a-button', {
      attrs: {
        "type": "link",
        "size": "small"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleGroupExpand(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.expanded ? '收起详情' : '查看详情') + " ")])], 1), item.expanded ? _c('div', {
      staticClass: "group-detail"
    }, _vm._l(item.subTasks, function (sub, idx) {
      var _sub$comment, _sub$comment2, _sub$comment3, _sub$comment4, _sub$comment5;
      return _c('div', {
        key: sub.taskId,
        staticClass: "sub-task"
      }, [_c('div', [_vm._v("办理人：" + _vm._s(sub.assigneeName || sub.assigneeId))]), _c('div', [_vm._v("审核意见：" + _vm._s(((_sub$comment = sub.comment) === null || _sub$comment === void 0 ? void 0 : _sub$comment.comment) || '无'))]), _c('div', [_vm._v("办理时间：" + _vm._s(sub.finishTime || sub.createTime))]), _c('div', [_vm._v("办理结果： "), ((_sub$comment2 = sub.comment) === null || _sub$comment2 === void 0 ? void 0 : _sub$comment2.type) == 1 ? _c('a-tag', {
        staticClass: "tag-border-green"
      }, [_vm._v("通过")]) : _vm._e(), ((_sub$comment3 = sub.comment) === null || _sub$comment3 === void 0 ? void 0 : _sub$comment3.type) == 3 || ((_sub$comment4 = sub.comment) === null || _sub$comment4 === void 0 ? void 0 : _sub$comment4.type) == 2 ? _c('a-tag', {
        staticClass: "tag-border-orange"
      }, [_vm._v("驳回")]) : _vm._e(), ((_sub$comment5 = sub.comment) === null || _sub$comment5 === void 0 ? void 0 : _sub$comment5.type) == 6 ? _c('a-tag', {
        staticClass: "tag-border-red"
      }, [_vm._v("不通过")]) : _c('span', [_vm._v("-")])], 1), idx !== item.subTasks.length - 1 ? _c('hr') : _vm._e()]);
    }), 0) : _vm._e()])])], 1);
  }), 1)], 1), ((_vm$flowListRaw = _vm.flowListRaw[_vm.flowListRaw.length - 1]) === null || _vm$flowListRaw === void 0 ? void 0 : _vm$flowListRaw.comment) == null ? _c('div', {
    staticClass: "hyd-drawer-select-person"
  }, [_c('div', [_vm._v("抄送人")]), _c('select-person', {
    ref: "selectGroups",
    attrs: {
      "tabList": _vm.usersTabList,
      "width": "100%"
    },
    model: {
      value: _vm.usersList,
      callback: function callback($$v) {
        _vm.usersList = $$v;
      },
      expression: "usersList"
    }
  })], 1) : _vm._e(), ((_vm$flowListRaw2 = _vm.flowListRaw[_vm.flowListRaw.length - 1]) === null || _vm$flowListRaw2 === void 0 ? void 0 : _vm$flowListRaw2.comment) == null ? _c('div', {
    staticClass: "audit"
  }, [_c('a-divider', {
    attrs: {
      "orientation": "left"
    }
  }, [_vm._v("审批意见")]), _c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请填写审批意见",
      "rows": 4,
      "max-length": 220
    },
    model: {
      value: _vm.comment,
      callback: function callback($$v) {
        _vm.comment = $$v;
      },
      expression: "comment"
    }
  }), _c('a-form-model', {
    ref: "addForm",
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "model": _vm.formObject,
      "rules": _vm.rules,
      "label-col": {
        span: 7,
        offset: 0
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId"
    }
  }, [_c('a-select', {
    attrs: {
      "filter-option": _vm.filterOption,
      "showSearch": true,
      "default-value": _vm.defaultOrganPostValue,
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    }
  }, _vm._l(_vm.options, function (item, index) {
    return _c('a-select-option', {
      attrs: {
        "value": index
      }
    }, [_vm._v(" " + _vm._s(item.organName + '/' + item.postName) + " ")]);
  }), 1)], 1)], 1)], 1), _vm.hasCustomLabel ? [_vm._l(_vm.inputSize, function (i) {
    return [_c('a-row', {
      key: i
    }, [_c('a-col', [_c('div', {
      attrs: {
        "label": _vm.inputKeyList[i - 1],
        "prop": 'key' + i
      }
    }, [_vm.inputTypeList[i - 1] == 'input' ? [_c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.inputKeyList[i - 1]) + ":")]), _c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      attrs: {
        "placeholder": "请输入内容",
        "maxLength": 255
      },
      model: {
        value: _vm.formObject.inputValueList[i - 1],
        callback: function callback($$v) {
          _vm.$set(_vm.formObject.inputValueList, i - 1, $$v);
        },
        expression: "formObject.inputValueList[i - 1]"
      }
    })], 1)] : _vm._e(), _vm.inputTypeList[i - 1] == 'img' ? [_c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.inputKeyList[i - 1]) + ":")]), _c('img', {
      staticStyle: {
        "width": "4.95rem",
        "height": "4.95rem"
      },
      attrs: {
        "src": _vm.signImgUrl,
        "alt": "签名图片"
      }
    })])] : _vm._e()], 2)])], 1)];
  })] : _vm._e()], 2), _c('div', {
    staticClass: "audit-btn"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onClickAudit
    }
  }, [_vm._v("通过")]), _c('a-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.onClickReturn
    }
  }, [_vm._v("驳回")]), _c('a-button', {
    attrs: {
      "plain": "",
      "type": "info"
    },
    on: {
      "click": _vm.onClickStop
    }
  }, [_vm._v("不通过")])], 1)], 1) : _vm._e()])])]), _c('a-card', {
    staticClass: "left-card disabled-cursor",
    attrs: {
      "bordered": false
    }
  }, [_c('fm-generate-form', {
    ref: "generateForm",
    attrs: {
      "data": _vm.formData,
      "value": _vm.fillData,
      "edit": false
    }
  })], 1), _c('a-modal', {
    attrs: {
      "title": "指定节点审核人",
      "visible": _vm.auditUserVisible
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form1,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_vm._l(_vm.flowApproverSetList, function (item, index) {
    return [_c('a-form-item', {
      key: index,
      attrs: {
        "label": item.taskName
      }
    }, [_c('select-person', {
      ref: "personPick",
      refInFor: true,
      attrs: {
        "tabList": _vm.userGroupTabList,
        "width": "100%"
      },
      model: {
        value: _vm.userGroupObj[item.taskDefKey],
        callback: function callback($$v) {
          _vm.$set(_vm.userGroupObj, item.taskDefKey, $$v);
        },
        expression: "userGroupObj[item.taskDefKey]"
      }
    })], 1)];
  })], 2)], 1), _c('a-modal', {
    attrs: {
      "title": "驳回操作",
      "visible": _vm.returnVisible
    },
    on: {
      "ok": _vm.returnHandleOk,
      "cancel": _vm.returnHandleCancel
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form1,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "驳回节点"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择驳回节点"
    },
    model: {
      value: _vm.targetKey,
      callback: function callback($$v) {
        _vm.targetKey = $$v;
      },
      expression: "targetKey"
    }
  }, _vm._l(_vm.newflowList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.taskDefKey
      }
    }, [_vm._v(" " + _vm._s(item.taskName) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-modal', {
    attrs: {
      "title": "继续处理",
      "visible": _vm.continueModalVisible
    },
    on: {
      "ok": _vm.handleContinue,
      "cancel": _vm.handleCancelContinue
    }
  }, [_c('p', [_vm._v("是否继续处理下一条待审批数据？")])])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };